import React from 'react';
import classnames from 'classnames';
import LoadingSpinner from '../LoadingSpinner';
import { Layout } from 'app/components/base/Layout';
import style from './style.css';

export const Overlay = ({
  show,
  transparent
}) => {
  const modifiers = {
    [style['overlay--hidden']]: !show,
    [style.transparent]: transparent
  };
  return (
    <Layout className={classnames(style.overlay, modifiers)} align="center center">
      {!!show && <LoadingSpinner size="large" />}
    </Layout>
  );
};

// TODO: move to Flow types
// Overlay.propTypes = {
//   show: PropTypes.bool,
//   transparent: PropTypes.bool
// };

Overlay.defaultProps = {
  show: false,
  transparent: false
};

export default Overlay;
